document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.product-slider');
  const prev = document.querySelector('.prev-slide');
  const next = document.querySelector('.next-slide');

  if (slider && prev && next) {
    prev.addEventListener('click', () => {
      slider.scrollBy({ left: -slider.clientWidth, behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      slider.scrollBy({ left: slider.clientWidth, behavior: 'smooth' });
    });
  }
});
